import { select, call, put, all } from 'redux-saga/effects';
import { isNumber } from '@bitComponents/utils/common';
import { actions as uiNeedsActions } from '../reducers/uiNeeds';
import { actions as manualActions } from '../reducers/manual';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import { megaMinderStatus } from '../minder/MegaMinder/megaMinderStatus';
import { commonActions } from '../reducers/common';
import { CQ_POTS, IVA } from '../catalogConstants';
import FrontSonda from '@gcloud-npm/utils.monitoring.front-sonda';
import { getProductOfferingOrion } from '../bitSagas/getProductOffering';
import { PRODUCT_TYPES } from '../utils/catalog';

const productTypeTranslation = {
  [PRODUCT_TYPES.MOBILE]: 'móvil',
  [PRODUCT_TYPES.LAND_LINE]: 'fija',
}

// A selector function that retrieves the apiNeeds state from the store
const offerStore = state => state.offer;
const contextStore = state => state.context.data;
const getErrorManagement = state => state.errorManagement;

const getMainProductOptions = ( productType, key ) => {
  const mainOptionsForUI = {
    options: [
      {
        actionId: '15',
        description: `Línea ${productTypeTranslation[productType]}`,
        productOfferingName: '',
        cqsiId: `${key}XXX`
      },
      {
        actionId: '1',
        description: `Línea ${productTypeTranslation[productType]}`,
        productOfferingName: '',
        cqsiId: `${key}XXXX`
      },
    ],
    thereIsPortability: true,
    mainOptionSelected: '1'
  };

  let mainOptions = [
    {
      actionId: '15',
      clientPhoneNumberToBeAppliedTo: null,
      cqsiId: '10001',
      description: `Línea ${productTypeTranslation[productType]}`,
      productType,
    },
    {
      actionId: '1',
      clientPhoneNumberToBeAppliedTo: null,
      cqsiId: '10002',
      description: `Línea ${productTypeTranslation[productType]}`,
      productType,
    },
  ];

  return {
    mainOptions,
    mainOptionsForUI,
  }
}

export function* getDuoProductsInfo({ showError, normalizeHttpErrors }) {
  // Dispatches an action to set the `loading` state to `true`
  yield put(
    loaderControlActions.setLoaderState({
      loading: true,
    })
  );

  const offerInfo = yield select(offerStore);
  const { allPOsToBuy, lmasProductOfferings } = offerInfo;
  
  try {
    
    const products = yield all(allPOsToBuy.map(productOfferingId => call(getProductOfferingOrion, {
      productOfferingId,
      normalizeHttpErrors,
      showError,
    })));
    
    if (products.length != allPOsToBuy.length) {
      const context = yield select(contextStore);
      const frontSonda = new FrontSonda({
        processName: "getProductsInfo",
        context,
        filePath: "sagas/manual",
      });

      allPOsToBuy.forEach(poToBuy => {
        let poExists = false;
        for(const productOfferingData of products){
          const { productOffering } = productOfferingData;
          if(poToBuy==productOffering){
            poExists = true;
            
          }
        }
        if(!poExists){
          frontSonda.fatalMessage({
            info: `No se encuentra el producto con id ${poToBuy} en Orion`,
            error: null,
          });
        }
      });
      
      const { handledErrors } = yield select(getErrorManagement);
      yield put(showError(handledErrors.BUSINESS_ERRORS.INCORRECT_PARAMS));

      return {
        ...megaMinderStatus.KO,
        errorInfo: "Producto no encontrado",
      };
    }

    const provisionalAgreementUrlAttachments = [];
    const legalTerms = [];
    const recurringChargesProducts = [];
    const promotions = [];
    let groupPriceBeforeDiscounts = 0;
    let groupPrice = 0;
    let unity = '';

    for(const productOfferingData of products){
      const { productOffering, name, pricesInfo, legal,  provisionalAgreementUrl } = productOfferingData;
      if(provisionalAgreementUrl){
        provisionalAgreementUrlAttachments.push({
          url: provisionalAgreementUrl,
        });
      }
      if(legal){
        legalTerms.push(legal);
      }
      if(lmasProductOfferings.includes(productOffering.toString())){
        
        const { mainOptions, mainOptionsForUI } = getMainProductOptions(
          PRODUCT_TYPES.MOBILE,
          "MOB",
        );
    
        yield put(
          manualActions.setExtendSelectElementsNeeds({
            cqId: "XXX",
            mainOptions,
            mainOptionsForUI,
            mainOptionSelected: null,
            productType: PRODUCT_TYPES.MOBILE,
            productOffering,
          })
        );
        if(pricesInfo?.recurringCharges?.promotionId){
          promotions.push(pricesInfo.recurringCharges.promotionId)
        }
        recurringChargesProducts.push({
          productOffering: {
            // id: productOffering,
            text: name,
          },
          promotionId: pricesInfo.recurringCharges.promotionId || null,
          promotionText: pricesInfo.recurringCharges.promotionText || '',
          priceBeforeDiscounts: pricesInfo.recurringCharges.priceBeforeDiscounts || '',
          finalPrice: pricesInfo.recurringCharges.finalPrice,
          unity: pricesInfo.recurringCharges.priceUnit,
          taxName: IVA,
          productType: PRODUCT_TYPES.MOBILE,
        });
        if(isNumber(pricesInfo.recurringCharges.priceBeforeDiscounts)){
          groupPriceBeforeDiscounts+=pricesInfo.recurringCharges.priceBeforeDiscounts;
        } else {
          groupPriceBeforeDiscounts+=pricesInfo.recurringCharges.finalPrice;
        }
        groupPrice+=pricesInfo.recurringCharges.finalPrice;
        unity=pricesInfo.recurringCharges.priceUnit;
      } else {  
        if(pricesInfo?.recurringCharges?.promotionId){
          promotions.push(pricesInfo.recurringCharges.promotionId)
        }
        recurringChargesProducts.push({
          productOffering: {
            // id: productOffering,
            text: name,
          },
          promotionId: pricesInfo.recurringCharges.promotionId || null,
          promotionText: pricesInfo.recurringCharges.promotionText || '',
          priceBeforeDiscounts: pricesInfo.recurringCharges.priceBeforeDiscounts || '',
          finalPrice: pricesInfo.recurringCharges.finalPrice,
          unity: pricesInfo.recurringCharges.priceUnit,
          taxName: IVA,
          productType: PRODUCT_TYPES.LAND_LINE,
        });
        if(isNumber(pricesInfo.recurringCharges.priceBeforeDiscounts)){
          groupPriceBeforeDiscounts+=pricesInfo.recurringCharges.priceBeforeDiscounts;
        } else {
          groupPriceBeforeDiscounts+=pricesInfo.recurringCharges.finalPrice;
        }
        groupPrice+=pricesInfo.recurringCharges.finalPrice;
      }
    }


    if (provisionalAgreementUrlAttachments.length > 0) {
      yield put(
        uiNeedsActions.setProvisionalAgreementData({ agreementApplies: true, attachments: provisionalAgreementUrlAttachments })
      );
    }

    let cart = {
      recurringCharges: {
        products: recurringChargesProducts,
        groupPriceBeforeDiscounts: groupPriceBeforeDiscounts !== groupPrice ? groupPriceBeforeDiscounts : '',
        groupPrice: groupPrice,
        unity,
      },
      oneTimeCharges: {},
      taxName: IVA,
      termsAndConditions: legalTerms,
    };

    yield put(uiNeedsActions.setPricesInfo(cart));
    yield put(commonActions.setAllPromosId(promotions));

    yield put(commonActions.setPoptSelected({ id: CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID }));

    return megaMinderStatus.OK;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export function* getDuoProductsAgreements({ showError, normalizeHttpErrors }) {
  // Dispatches an action to set the `loading` state to `true`
  yield put(
    loaderControlActions.setLoaderState({
      loading: true,
    })
  );

  const offerInfo = yield select(offerStore);
  const { allPOsToBuy, lmasProductOfferings } = offerInfo;
  
  try {
    
    const products = yield all(allPOsToBuy.map(productOfferingId => call(getProductOfferingOrion, {
      productOfferingId,
      normalizeHttpErrors,
      showError,
    })));
    
    if (products.length != allPOsToBuy.length) {
      const context = yield select(contextStore);
      const frontSonda = new FrontSonda({
        processName: "getProductsInfo",
        context,
        filePath: "sagas/manual",
      });

      allPOsToBuy.forEach(poToBuy => {
        let poExists = false;
        for(const productOfferingData of products){
          const { productOffering } = productOfferingData;
          if(poToBuy==productOffering){
            poExists = true;
            
          }
        }
        if(!poExists){
          frontSonda.fatalMessage({
            info: `No se encuentra el producto con id ${poToBuy} en Orion`,
            error: null,
          });
        }
      });
      
      const { handledErrors } = yield select(getErrorManagement);
      yield put(showError(handledErrors.BUSINESS_ERRORS.INCORRECT_PARAMS));

      return {
        ...megaMinderStatus.KO,
        errorInfo: "Producto no encontrado",
      };
    }

    const provisionalAgreementUrlAttachments = [];

    let lmaAltBuyProcessInfo = {};

    for(const productOfferingData of products){
      const { productOffering, provisionalAgreementUrl, name, pricesInfo, buyProcessUrl } = productOfferingData;
      if(provisionalAgreementUrl){
        provisionalAgreementUrlAttachments.push({
          url: provisionalAgreementUrl,
        });
      }
      if(lmasProductOfferings.includes(productOffering.toString())){
        lmaAltBuyProcessInfo.lmaBuyProcessUrl=buyProcessUrl;
        lmaAltBuyProcessInfo.lmaName=name;
        lmaAltBuyProcessInfo.lmaPrice=pricesInfo.recurringCharges.finalPrice;
      } else {
        lmaAltBuyProcessInfo.bafName=name;
      }
    }
    yield put(
      manualActions.setLMABuyProcessInfo({
        lmaAltBuyProcessInfo,
      })
    );

    if (provisionalAgreementUrlAttachments.length > 0) {
      yield put(
        uiNeedsActions.setProvisionalAgreementData({ agreementApplies: true, attachments: provisionalAgreementUrlAttachments })
      );
    }

    return megaMinderStatus.OK;
  } catch (e) {
    console.log(e);
    return null;
  }
}
